module.exports = __webpack_public_path__ + "img/1482899844.4d4b2870.jpg";